export default {
  placeholder: 'Caută',
  cancel: 'Anulează',
};
